import { App } from "@/app";
import { Transition as BaseTransition } from "@unseenco/taxi";
import gsap from "@lib/gsap";
import PixelGrid from "@/classes/PixelGrid";
import { MenuController } from "@lib/menu-controller";

const pixelGrid = new PixelGrid();

export class Transition extends BaseTransition {
  async onLeave({
    from,
    trigger,
    done,
  }: {
    from: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    // console.log("🚀 Page leaving - fade out");

    // await pixelGrid.animateIn();

    if (MenuController.isMenuOpen) {
      await App.pages.transitionOut({ from, trigger });
      await gsap.delayedCall(0.1, () => {
        MenuController.closeMenu();
      });
    } else {
      await pixelGrid.animateIn();
      await App.pages.transitionOut({ from, trigger });
    }
    done();
  }

  async onEnter({
    to,
    trigger,
    done,
  }: {
    to: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    pixelGrid.animateOut();
    App.pages.transitionIn({ to, trigger });

    done();
  }
}

/* -- ... Transition */
